<template>
  <el-table v-loading="loading" :data="tableData" border style="width: 100%">
    <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
    <el-table-column prop="orderCode" label="订单号" align="left" />
    <el-table-column prop="backDate" label="销退日期" align="left" />
    <el-table-column prop="backCode" label="销退单号" align="left" />
    <el-table-column prop="productCode" label="物品代码" align="left" />
    <el-table-column prop="productName" label="商品名称" align="left" />
    <el-table-column prop="backCount" label="销退数量" align="left" />
  </el-table>
</template>
<script type="es6">
import { getSellingBackList } from '@/API';
export default {
  data () {
    return {
      tableData: [],
      loading: false
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {},
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getSellingBackList(this.strContractCode).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
